import { makeStyles } from "@mui/styles";
import TablesHistory from "./tablesHistory";
import { BoxStyled } from "styledComponents/component";

let useStyles = makeStyles((theme) => ({
  gridPayment: {},
  gridCard: {
    width: 200,
    // minHeight: 145,
  },
  modal: {
    width: "50%",
    minHeight: 500,
    backgroundColor: "#ffffff",
    zIndex: 100,
    boxShadow: theme.shadows[5],
    padding: theme.spacing(2, 4, 5),
    borderRadius: 5,
  },
  container: {
    width: "97%",
    margin: "auto",
  },
}));

export default function WithdrawOnlineHistory() {
  let classes = useStyles();

  return (
    <div>
      <BoxStyled>
        <div className={classes["container"]}>
          <div className={`${classes["gridPayment"]} flex justify-between`}>
            <div>
              <h1 className=" mb-3 mt-2 text-lg text-gray-600 text-md">
                {`لیست درخواست های برداشت آنی `}
              </h1>
            </div>
          </div>

          <div>
            <TablesHistory />
          </div>
        </div>
      </BoxStyled>
    </div>
  );
}
